import React from "react";
import Banner from "../../components/Widgets/Banner";

const Blog = () => {
    return (
        <div className="blog">
            <Banner route="our blogs">

            </Banner>
        </div>
    )
}

export default Blog;